import _ from "lodash"

import { HTTP_METHODS } from "./../../../../../constants"
import { makeExternalCall } from "./../../../../../helpers"
import { isRLTLang } from "../../../../../i18n"


const FETCH_OPTIONS_ENDPOINT = "/api/pa/options/list?list_number=9"

const formatOptions = (options) => options.map((option) => (
  { label: isRLTLang() ? option.valueAr : option.valueFr, value: option.rank }))


export const eventContextUIHelper = (callback, keyword) => {

  let endpoint = FETCH_OPTIONS_ENDPOINT
  let query = {}
  if (!_.isEmpty(keyword)) {
    query = { q: keyword }
  }

  return new Promise((resolve, reject) =>
    makeExternalCall(HTTP_METHODS.GET, endpoint, {}, {}, query)
      .then(resp => {
        let result = {}
        if (_.isPlainObject(resp.data)) {
          result = [resp.data]
        } else {
          result = resp.data
        }
        resolve(callback(formatOptions(result)))
      })
      .catch(err => reject(err.response))
  )
    }




    const formatContextOptions = (options) => {
      let values = {}
      options.forEach((option) => {
          values[option.rank] = isRLTLang() ? option.valueAr : option.valueFr
      })
      return values;
  }
  
  
  export const getContextOptions = (callback, keyword) => {

    let endpoint = FETCH_OPTIONS_ENDPOINT
    let query = {}
    if (!_.isEmpty(keyword)) {
      query = { q: keyword }
    }
  
    return new Promise((resolve, reject) =>
      makeExternalCall(HTTP_METHODS.GET, endpoint, {}, {}, query)
        .then(resp => {
          let result = {}
          if (_.isPlainObject(resp.data)) {
            result = [resp.data]
          } else {
            result = resp.data
          }
          resolve(callback(formatContextOptions(result)))
        })
        .catch(err => reject(err.response))
    )
      }


/* export const CONTEXT = { 
  1: "EVENT.CONTEXT.GENERAL_EVENT",
  2: "EVENT.CONTEXT.GUIDE_CAREER",
  3: "EVENT.CONTEXT.FOLLOW_UP" ,
  4: "EVENT.CONTEXT.OTHER"
}

export const eventContextUIHelper = (intl) =>
  Object.keys(CONTEXT).map((key) => ({
    value: parseInt(key),
    label: intl.formatMessage({ id: CONTEXT[key] }),
  })) */
